import React, { useState } from "react";
import { useGetGymlistQuery ,useGetGymlistallQuery } from "../../../store/api/account";
import { useUpdatePlanMutation } from "../../../store/api/adminplan";
import { useNavigate, useLocation } from "react-router-dom";
function AdminPlanEdit() {
  const location = useLocation();
  const EditPlan = location?.state?.data;
  const navigate = useNavigate();
  const [selectedGym, setSelectedGym] = useState(EditPlan?.domain || "");
  const [planType, setPlanType] = useState(EditPlan?.plan_type || "");
  const [planDuration, setPlanDuration] = useState(EditPlan?.plan_duration_type || "");
  const [planEndDate, setPlanEndDate] = useState(EditPlan?.plan_end_date?.split("T")[0] || "");
  const [planSlabs, setPlanSlabs] = useState(
    EditPlan?.plan_slab?.length > 0
      ? EditPlan.plan_slab.map((slab) => ({
        id: slab.id || null,
        orderNo: slab.order_no || null,
        minMember: slab.min_member || "",
        maxMember: slab.max_member || "",
        slabAmount: slab.slab_amount || "",
      }))
      : [{ id: null, orderNo: null, minMember: "", maxMember: "", slabAmount: "" }]
  );
  const handleSlabBlur = (index, e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value);
  
    if (numericValue <= 0 || isNaN(numericValue)) {
      setFeedbackMessage({ type: "error", message: `${name} must be greater than 0.` });
  
      const updatedSlabs = [...planSlabs];
      updatedSlabs[index][name] = ""; //
      setPlanSlabs(updatedSlabs);
    } else {
      setFeedbackMessage({ type: "", message: "" });
    }
  };

  
  const [feedbackMessage, setFeedbackMessage] = useState({ type: "", message: "" });

  const [updatePlan] = useUpdatePlanMutation();
  const { data: tabledata } = useGetGymlistallQuery();

  const gymOptions = tabledata?tabledata.map((gym) => ({ value: gym.id, label: gym.gym_name }))
    : [];
   
    console.log(EditPlan,"editplan"); 
const gymId =selectedGym
const selectedGym1 = gymOptions.find(gym => gym.value === gymId);



const handleSlabChange = (index, e) => {
  const { name, value } = e.target;
  const numericValue = parseFloat(value);

  if (numericValue < 0) {
    setFeedbackMessage({ type: "error", message: `${name} cannot be a negative number.` });
    return;
  }
  setFeedbackMessage({ type: "", message: "" });
  const updatedSlabs = [...planSlabs];
  updatedSlabs[index][name] = value;
  setPlanSlabs(updatedSlabs);
};
const addNewSlab = () => {
  setPlanSlabs([...planSlabs, { id: null, orderNo: null, minMember: "", maxMember: "", slabAmount: "" }]);
};
  
  const handleSubmit = async () => {
    const errors = planSlabs.map((slab, index) => ({
      minMember: slab.minMember === "" ? "Min Member is required" : "",
      maxMember: slab.maxMember === "" ? "Max Member is required" : "",
      slabAmount: slab.slabAmount === "" ? "Slab Amount is required" : "",
    }));
    const hasErrors = errors.some(
      (error) => error.minMember || error.maxMember || error.slabAmount
    );

    if (hasErrors) {
      setFeedbackMessage({ type: "error", message: "Please fill all required fields in slab section." });

      setTimeout(() => {

      }, 2000);
      return;
    }
    if (!selectedGym) {
      setFeedbackMessage({ type: "error", message: "Please select a gym." });
      return;
    }
    
    
    const updatedPlan = {
      id: EditPlan.id,
      plan_type: planType,
      plan_end_date: planEndDate,
      plan_name: selectedGym.label,
      plan_duration_type: planDuration,
      domain: selectedGym,
      plan_slab: planSlabs.map((slab) => ({
        id: slab.id || null,
        order_no: slab.orderNo || null,
        min_member: slab.minMember,
        max_member: slab.maxMember,
        slab_amount: slab.slabAmount,
      })),
    };

    try {
      
      const response = await updatePlan({ id: EditPlan.id, data: updatedPlan }).unwrap();
      if (response?.data) {
        setFeedbackMessage({ type: "success", message: "Plan updated successfully!" });
        setTimeout(() => {
          navigate("/adminplan-list",{ state: { pageName: "AdminPlan" }});
        }, 2000);
      } else {
        setFeedbackMessage({ type: "error", message: "Failed to update the plan." });
      }

    } catch (error) {
    
      const errorMessage = error?.data?.error || "Error updating plan.";
      setFeedbackMessage({ type: "error", message: errorMessage });
    }


  };
  return (

    <div className="w-full rounded-xl mt-2  mx-auto py-1">
      <div className="py-4 bg-white rounded-lg shadow px-3">
      <h2 className=" py-3 px-4 font-inter text-2xl text-[#333843] font-semibold">Edit Admin Plan</h2>
        
        <div className="grid grid-cols-2 gap-4 mx-4 mb-4 mt-3">
          <div>
            <label className="block text-sm font-medium text-black-700">Gym Name <span className="text-red-500">*</span></label>
            <select
              value={selectedGym || ""}
              onChange={(e) => {
                const selected = gymOptions.find((gym) => gym.value === parseInt(e.target.value, 10));
                console.log(selected,"hello");
                
                setSelectedGym(selected.value || { value: "", label: "" });
              }}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              
              {gymOptions.map((gym) => (
                <option key={gym.value} value={gym.value}>
                  {gym.label}
                </option>
              ))}
            </select>
          </div>
          <div className="mx-2">
            <label className="block text-sm font-medium text-black-700">Plan Type <span className="text-red-500">*</span></label>
            <select
              value={planType}
              onChange={(e) => setPlanType(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            >
              <option value="POSTPAID">POSTPAID</option>
              <option value="PREPAID">PREPAID</option>
            </select>
          </div>
          <div className="gap-4">
            <label className="block text-sm font-medium text-black-700">Plan Duration <span className="text-red-500">*</span></label>
            <select
              value={planDuration}
              onChange={(e) => setPlanDuration(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            >
              <option value="MONTHLY">MONTHLY</option>
              <option value="QUARTLY">QUARTLY</option>
              <option value="HALFYEARLY">HALFYEARLY</option>
              <option value="YEARLY">YEARLY</option>
            </select>
          </div>
          <div className="mx-2">
            <label className="block text-sm font-medium text-black-700">Plan End Date <span className="text-red-500">*</span></label>
            <input
              type="date"
              value={planEndDate}
              onChange={(e) => setPlanEndDate(e.target.value)}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="col-span-2 mt-3">
            {planSlabs.map((slab, index) => (
              <div key={slab.id || index} className="flex space-x-3 mb-3">
                <input
                  type="number"
                  name="minMember"
                  placeholder="Min Member"
                  value={slab.minMember || ""}
                  onChange={(e) => handleSlabChange(index, e)}
                  onBlur={(e) => handleSlabBlur(index, e)}
                  className="w-1/3 p-2 border rounded-lg"
                />
                <input
                  type="number"
                  name="maxMember"
                  placeholder="Max Member"
                  value={slab.maxMember || ""}
                  onChange={(e) => handleSlabChange(index, e)}
                  onBlur={(e) => handleSlabBlur(index, e)}
                  className="w-1/3 p-2 border rounded-lg"
                />
                <input
                  type="text"
                  name="slabAmount"
                  placeholder="Slab Amount"
                  value={slab.slabAmount || ""}
                  onChange={(e) => handleSlabChange(index, e)}
                  onBlur={(e) => handleSlabBlur(index, e)}
                  className="w-1/3 p-2 border rounded-lg"
                />
              </div>
              
            ))}
            <button onClick={addNewSlab} className="px-4 py-2 bg-secondary text-white rounded-lg">
              Add Slab
            </button>
          </div>
        </div>
        {feedbackMessage?.type === "success" && (
          <div
            className="mt-3 mx-3 rounded-lg px-4 py-3 text-md font-medium bg-green-100 text-green-700 border border-green-300"
            role="alert"
          >
            {feedbackMessage.message}
          </div>
        )}
        {feedbackMessage?.type === "error" && (
          <div
            className="mt-3 mx-3 rounded-lg px-4 py-3 text-md font-medium bg-red-100 text-red-700 border border-red-300"
            role="alert"
          >
            {feedbackMessage.message}
          </div>
        )}
        <div className="flex justify-end mt-6 mx-4 space-x-4">
          <button className="px-4 py-2 bg-gray-300 rounded-lg" onClick={() => { navigate("/adminplan-list",{ state: { pageName: "AdminPlan" }})}}>Cancel</button>
          <button className="px-4 py-2 bg-secondary text-white rounded-lg" onClick={handleSubmit}>
            Update Plan
          </button>
        </div>
      </div>

    </div>
  );
}

export default AdminPlanEdit;
